//import jwt_decode from "jwt-decode";

import {showProcessSuccessMessage, showProcessErrorMessage} from "../../state/alertHelpers.js";

import {
    getSettings, updateErpSettings, updateGeneralSettings, updateMailSettings, updateCompanySettings
} from "../../services/modules/settings/settingsService";

// import CryptoJS from 'crypto-js';


export const state = {
    erpSettings: {},
    generalSettings: {},
    mailSettings: {},
    settingsLoading: false,
    apiBaseUrl: null,
    companyLogo: null,
};

export const mutations = {
    setErpSettings(state, data) {
        state.erpSettings = data;
    },
    setGeneralSettings(state, data) {
        state.generalSettings = data;
    },
    setMailSettings(state, data) {
        state.mailSettings = data;
    },
    setSettingsLoading(state, data) {
        state.settingsLoading = data;
    },
    setApiBaseUrl(state, newBaseUrl) {
        state.apiBaseUrl = newBaseUrl;
    },
    setCompanyLogo(state,data) {
        state.companyLogo = data;
    }
}

export const getters = {
        getCurrencyLabels(state) {
            let currencyLabels = [
                {id: state.erpSettings.netsisUsdCode, label: " $"},
                {id: state.erpSettings.netsisEuroCode, label: " €"},
                {id: state.erpSettings.netsisGbpCode, label: " £"}
            ]
            return currencyLabels;
        },
    getPaymentMethodDiscounts(state) {
        return state.erpSettings.paymentMethodDiscount;
    },
    currencyCurrentProcess(state) {
        return state.erpSettings.currencyCurrentProcess;
        },
    }
;

export const actions = {
    async fetchLogo(context, data) {
        context.commit("setCompanyLogo",data);
    },
    async fetchSettings(context, {params, body}) {

        let result = await getSettings(params, body);

        if (result.data.success) {
            let resultObject = result.data.data;

            // const decrypt = (encryptedText) => {
            //     const key = CryptoJS.enc.Utf8.parse('b14ca5898a4e4133bbce2ea2315a1916');
            //     const iv = CryptoJS.enc.Hex.parse('00000000000000000000000000000000'); // Match the C# byte[16] iv
            //
            //     const decrypted = CryptoJS.AES.decrypt(encryptedText, key, {
            //         iv: iv,
            //         mode: CryptoJS.mode.CBC,
            //         padding: CryptoJS.pad.Pkcs7
            //     });
            //
            //     return decrypted.toString(CryptoJS.enc.Utf8);
            // }

            context.commit("setErpSettings", {
                server: (resultObject.server),
                dbName: (resultObject.dbName),
                dbUserName: (resultObject.dbUserName),
                dbPassword: (resultObject.dbPassword),
                netsisCompanyName: resultObject.netsisCompanyName,
                netsisBranchCode: resultObject.netsisBranchCode,
                orderApprove: resultObject.orderApprove,
                salesPersonOffersAdminApproveToCustomer: resultObject.salesPersonOffersAdminApproveToCustomer,
                netsisUserName: resultObject.netsisUserName,
                netsisUserPassword: resultObject.netsisUserPassword,
                netsisOrderSerie: resultObject.netsisOrderSerie,
                netsisCurrentSerie: resultObject.netsisCurrentSerie,
                netOpenXRestUrl: (resultObject.netOpenXRestUrl),
                // netOpenXRestRestart: resultObject.netOpenXRestRestart,
                netsisWarehouseCode: resultObject.netsisWarehouseCode,
                onlyCurrency: resultObject.onlyCurrency,//ekle
                netsisCurrencySale: resultObject.netsisCurrencySale,
                netsisCurrencySaleType: resultObject.netsisCurrencySaleType,
                netsisUsdCode: resultObject.netsisUsdCode,
                netsisEuroCode: resultObject.netsisEuroCode,
                netsisGbpCode: resultObject.netsisGbpCode,
                eLogoUserName: (resultObject.eLogoUserName),
                eLogoPassword: (resultObject.eLogoPassword),
                stockListShowBalance: resultObject.stockListShowBalance,
                hideBalanceType: resultObject.hideBalanceType ? resultObject.hideBalanceType : 1,// Bu alan doğru mu emin değilim
                stockBalanceLimit: resultObject.stockBalanceLimit,
                cartShowBalance: resultObject.cartShowBalance,
                conditionOperation: resultObject.conditionOperation,
                campaignOperation: resultObject.campaignOperation,
                paymentMethodDiscount: resultObject.paymentMethodDiscount,
                netsisSalePrice: resultObject.netsisSalePrice,
                specialCode1: resultObject.specialCode1,
                specialCode2: resultObject.specialCode2,
                paymentSaveErp: resultObject.paymentSaveErp,
                currentSearch: resultObject.currentSearch,
                stockSearch: resultObject.stockSearch,
                stockBalanceAddCart: resultObject.stockBalanceAddCart,
                stockBalanceUnderAddCart: resultObject.stockBalanceUnderAddCart,
                zeroStockBalanceGet: resultObject.zeroStockBalanceGet,
                minimumStockConstraint: resultObject.minimumStockConstraint,
                minimumStockMultipleConstraint: resultObject.minimumStockMultipleConstraint,
                maximumStockConstraint: resultObject.maximumStockConstraint,
                stockVatStatus: resultObject.stockVatStatus,
                stockListOrderBy: resultObject.stockListOrderBy,
                cashSafeCode: resultObject.cashSafeCode,
                cashCurrentActionDescription: resultObject.cashCurrentActionDescription,
                creditCardSafeCode: resultObject.creditCardSafeCode,
                creditCardCurrentActionDescription: resultObject.creditCardCurrentActionDescription,
                multipleCompanyCurrentBalance: resultObject.multipleCompanyCurrentBalance,
                multipleCompanyStockBalance: resultObject.multipleCompanyStockBalance,
                userBranch: resultObject.userBranch,
                userWarehouse: resultObject.userWarehouse,
                userSafe: resultObject.userSafe,
                cartCurrencyShow: resultObject.cartCurrencyShow,
                stockBalanceType: resultObject.stockBalanceType,
                minimumSalePriceControl: resultObject.minimumSalePriceControl,
                minimumSalePriceField: resultObject.minimumSalePriceField,
                localWarehouse: resultObject.localWarehouse,
                localWarehouseCode: resultObject.localWarehouseCode,
                allBranchShow: resultObject.allBranchShow,
                basketNotUpdate: resultObject.basketNotUpdate,
                projectCode: resultObject.projectCode,
                cartProjectProcess: resultObject.cartProjectProcess,
                projectName: resultObject.projectName,
                projectPhaseCustomerOrderEdit: resultObject.projectPhaseCustomerOrderEdit,
                salesPersonOrderApprove: resultObject.salesPersonOrderApprove,
                currencyCurrentProcess: resultObject.currencyCurrentProcess,

            });

            context.commit("setGeneralSettings", {
                companyLogo: resultObject.companyLogo,
                companyName: resultObject.companyName,
                companyCity: resultObject.companyCity,
                companyTown: resultObject.companyTown,
                companyAddress: resultObject.companyAddress,
                companyPhoneNumber: resultObject.companyPhoneNumber,
                companyEmail: resultObject.companyEmail,
                companyWeb: resultObject.companyWeb,
                customerOrderInfoEmail: resultObject.customerOrderInfoEmail,
                customerOfferInfoEmail: resultObject.customerOfferInfoEmail,
                customerLockOrderProcess: resultObject.customerLockOrderProcess,
                /*customerTicketInfoEmailToSalesPerson: resultObject.customerTicketInfoEmailToSalesPerson,
                unApproveOfferWaterMark: resultObject.unApproveOfferWaterMark,
                mailBgColor: resultObject.mailBgColor*/
            });

            context.commit("setMailSettings", {
                emailSenderName: resultObject.emailSenderName,
                email: resultObject.email,
                emailPassword: (resultObject.emailPassword),
                emailPort: resultObject.emailPort,
                emailHost: (resultObject.emailHost),
                emailSSL: resultObject.emailSSL
            });

        }

        return result;

    },

    async erpSettingUpdate(context, {params, body}) {
        context;
        let result = await updateErpSettings(params, body);
        if (result.data.success)
            showProcessSuccessMessage({
                title: 'İşlem Başarılı',
                text: result.data.message
            }).then(() => {
                location.reload();
            })
        else
            showProcessErrorMessage({
                title: 'İşlem Başarısız',
                text: result.data.message
            })
        return result;
    },
    async generalSettingsUpdate(context, {params, body}) {
        context;
        let result = await updateGeneralSettings(params, body);

        if (result.data.success)
            showProcessSuccessMessage({
                title: 'İşlem Başarılı',
                text: result.data.message
            })
        else
            showProcessErrorMessage({
                title: 'İşlem Başarısız',
                text: result.data.message
            })
        return result;
    },

    async mailSettingsUpdate(context, {params, body}) {
        context;
        let result = await updateMailSettings(params, body);

        if (result.data.success)
            showProcessSuccessMessage({
                title: 'İşlem Başarılı',
                text: result.data.message
            })
        else
            showProcessErrorMessage({
                title: 'İşlem Başarısız',
                text: result.data.message
            })
        return result;
    },
    async companySettingsUpdate(context, {params, body}) {
        context;
        let result = await updateCompanySettings(params, body);
        if (result.data.success)
            showProcessSuccessMessage({
                title: 'İşlem Başarılı',
                text: result.data.message
            })
        else
            showProcessErrorMessage({
                title: 'İşlem Başarısız',
                text: result.data.message
            })
        return result;
    },
};
